export default __webpack_public_path__ + "static/jeffrie-2a5b882bb81084ede847cfc4ca58e513.png";